module.exports = __webpack_public_path__ + "img/hr-rock-big-13.d2e58d4e.png";